import gql from 'graphql-tag';

export default gql`
query getAllWorkspaceDocumentsList {
  documents {
    edges {
      node {
        id
        title
        workspaceId
      }
    }
  }
}
`;
